import React, { createContext, useContext } from "react";
import { useSnackbar } from "notistack";

const AppNotificationContext = createContext();

export const AppNotificationProvider = ({ children }) => {
  const { enqueueSnackbar } = useSnackbar();

  const notify = (message, variant = "default", options = {}) => {
    enqueueSnackbar(message, {
      variant,
      autoHideDuration: 4000,
      anchorOrigin: { vertical: "top", horizontal: "right" },
      ...options,
    });
  };

  return (
    <AppNotificationContext.Provider value={{ notify }}>
      {children}
    </AppNotificationContext.Provider>
  );
};

export const useAppNotification = () => useContext(AppNotificationContext);